import { SuspenseWithPerf } from '@upflowy/firestore';
import { ErrorBoundary } from '@upflowy/logger';
import React from 'react';
import styled from 'styled-components';

import Loading from './components/Loading';
import Routes from './components/Routes';
import { AppProvider } from './providers/app-provider';
import { NetworkErrorHandlerProvider } from './providers/network-error-handler-provider';

const ErrorContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  *:first-child {
    margin-top: 20vh;
  }
  & > * {
    max-width: 80%;
  }
`;

const App = () => (
  <ErrorBoundary
    fallback={({ error, resetError }) => (
      <ErrorContainer>
        <h1>Something went wrong. Our team has been notified.</h1>
        <div>{error.toString()}</div>
        <button
          type="button"
          onClick={() => {
            resetError();
          }}
        >
          Click here to try again!
        </button>
      </ErrorContainer>
    )}
  >
    <SuspenseWithPerf traceId="test" fallback={<Loading />}>
      <NetworkErrorHandlerProvider>
        <AppProvider>
          <Routes />
        </AppProvider>
      </NetworkErrorHandlerProvider>
    </SuspenseWithPerf>
  </ErrorBoundary>
);

export default App;
